<template>
  <div>
    <div class="text-center">
      <h2 class="mt-6 text-2xl font-extrabold text-gray-300">
        {{ text.title }}
      </h2>
      <p class="mt-2 whitespace-normal text-sm text-gray-400">
        {{ text.subtitle }}
      </p>
    </div>

    <div class="mt-8">
      <div
        is="transition"
        v-on:enter="enter"
        v-on:leave="leave"
        v-bind:css="false"
        appear
        mode="out-in"
      >
        <div :key="1" v-if="form_state" class="mt-6 space-y-6">
          <ontick-input
            placeholder="Apenas números"
            v-model="user.cpf"
            label="CPF/CNPJ"
            name="cpf"
            type="text"
            v-mask="isCnpj ? mask_cnpj : mask_cpf"
            v-validate="'required'"
            :error="errors.first('cpf')"
            bg="bg-ontick-steel-500"
          ></ontick-input>

          <ontick-input
            placeholder="ontick@ontick.com.br"
            v-model="user.email"
            label="Email"
            name="email"
            type="email"
            v-validate="'required|email'"
            :error="errors.first('email')"
            bg="bg-ontick-steel-500"
          ></ontick-input>
          <div class="space-y-6">
            <ontick-button class="w-full" @click.native="forgotPassword()">
              <span v-show="!loading_buttons">Enviar</span>
              <span v-show="loading_buttons" v-html="$icons.loading"></span>
            </ontick-button>
            <div class="space-y-6 text-center">
              <div class="border-ontick-steel-500 border"></div>
              <div class="text-sm">
                <p @click="$emit('returnLogin')" class="text-gray-300">
                  Voltar
                </p>
              </div>
            </div>
          </div>
        </div>
        <div :key="2" v-else>
          <div
            is="transition"
            v-on:enter="enter"
            v-on:leave="leave"
            v-bind:css="false"
            appear
            mode="out-in"
          >
            <div :key="3" v-if="!success" class="space-y-6">
              <div>
                <label
                  for="code"
                  class="mb-2 block text-sm font-medium text-gray-300"
                >
                  Código
                </label>
                <div class="mt-1">
                  <pin-code-input
                    v-model="user.code"
                    :secure="false"
                    :characterPreview="false"
                    :length="6"
                    v-validate="'required'"
                    name="code"
                    :error="errors.first('code')"
                  />
                </div>

                <div v-if="resend_number <= 3" class="mt-2 pb-3">
                  <a
                    v-show="!resend_code"
                    @click="resendConfirmationCode()"
                    class="text-ontick-blue-500 cursor-pointer text-right text-xs font-medium"
                    >Reenviar código</a
                  >
                  <contador v-if="resend_code" />
                </div>
              </div>

              <div v-if="resend_number > 3">
                <p class="text-ontick-yellow-500 font-medium">
                  Limite de reevio foi atingido.
                </p>
              </div>

              <div>
                <label
                  for="new_password"
                  class="block text-sm font-medium text-gray-300"
                >
                  Nova senha
                </label>
                <div class="mt-1">
                  <password-validate
                    v-model="user.new_password"
                    name="new_password"
                    v-validate="'required'"
                    :error="errors.first('new_password')"
                    @validatePassword="user.new_password = $event"
                  />
                </div>
              </div>
              <ontick-button
                class="w-full"
                @click.native="forgotPasswordSubmit()"
              >
                <span v-show="!loading_buttons">{{ text.button }}</span>
                <span v-show="loading_buttons" v-html="$icons.loading"></span>
              </ontick-button>
            </div>
            <div :key="4" v-else class="flex justify-center">
              <div class="py-16">
                <success-icon
                  :active="success"
                  title=" Senha alterada com sucesso"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import PinCodeInput from "vue-pincode-input";
import PasswordValidate from "./password.validate.component.vue";
import Contador from "@/app/shared/components/contador/timer.component.vue";
import SuccessIcon from "@/app/shared/components/basic/ontick-success.component.vue";
import filter from "@/app/shared/filters/filter.js";

export default {
  mixins: [filter],

  components: {
    PinCodeInput,
    PasswordValidate,
    Contador,
    SuccessIcon,
  },

  data() {
    return {
      user: {
        email: "",
        phone: "",
        code: "",
        new_password: "",
        cpf: "",
      },

      loading_buttons: false,

      resend_code: false,
      resend_number: 0,
      email_register: "",
      form_state: true,
      success: false,
    };
  },

  computed: {
    isCnpj() {
      return this.user.cpf.length > 14;
    },
    text() {
      if (this.$route.query.mode !== "create_password") {
        return {
          title: "Esqueci minha senha",
          subtitle: this.form_state
            ? "Um código de renovação de senha será enviado por email"
            : `O código de renovação de senha foi enviado para o email ${this.email_register}`,
          button: "Alterar",
        };
      }
      return {
        title: "Criar nova senha",
        subtitle: this.form_state
          ? "Um código de criação de senha será enviado por email"
          : `O código de criação de senha foi enviado para o email ${this.email_register}`,
        button: "Criar",
      };
    },
  },

  methods: {
    enter(el, done) {
      TweenMax.fromTo(
        el,
        1,
        {
          autoAlpha: 0,
          scale: 1.5,
        },
        {
          autoAlpha: 1,
          scale: 1,
          transformOrigin: "50% 50%",
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },
    leave(el, done) {
      TweenMax.fromTo(
        el,
        1,
        {
          autoAlpha: 1,
          scale: 1,
        },
        {
          autoAlpha: 0,
          scale: 0.8,
          ease: Power4.easeOut,
          onComplete: done,
        }
      );
    },

    forgotPassword() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.loading_buttons = true;
          let clientMetadata = {
            [this.isCnpj ? "custom:user_cnpj" : "custom:user_cpf"]:
              this.user.cpf.replace(/[^\d]/g, ""),
          };
          Auth.forgotPassword(this.user.email, clientMetadata)
            .then((response) => {
              this.email_register = response.CodeDeliveryDetails.Destination;
              this.form_state = false;
            })
            .catch((error) => {
              this.$swal({
                title: error.message,
                icon: "error",
                timer: 4000,
              });
            })
            .finally(() => {
              this.loading_buttons = false;
            });
        }
      });
    },

    resendConfirmationCode() {
      this.resend_number = sessionStorage.getItem("resend");
      this.loading_buttons = true;
      Auth.forgotPassword(this.user.email)
        .then((response) => {
          this.email_register = response.CodeDeliveryDetails.Destination;
          this.resend_code = true;
          this.resend_number = parseInt(this.resend_number) + 1;
          sessionStorage.setItem("resend", this.resend_number);
          setTimeout(() => {
            this.resend_code = false;
          }, 60000);
        })
        .catch((error) => {
          this.$swal({
            title: error.message,
            icon: "error",
            timer: 4000,
          });
        })
        .finally(() => {
          this.loading_buttons = false;
        });
    },

    forgotPasswordSubmit() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.loading_buttons = true;
          Auth.forgotPasswordSubmit(
            this.user.email,
            this.user.code,
            this.user.new_password
          )
            .then(() => {
              this.success = true;
              setTimeout(() => {
                this.$emit("returnLogin");
              }, 4000);
            })
            .catch((error) => {
              this.$swal({
                title: error.message,
                icon: "error",
                timer: 4000,
              });
            })
            .finally(() => {
              this.loading_buttons = false;
            });
        }
      });
    },
  },
  created() {
    if (this.$route.query.cpf) this.user.cpf = this.$route.query.cpf;
    if (this.$route.query.email) this.user.email = this.$route.query.email;
  },
  unmounted() {
    sessionStorage.removeItem("resend");
  },
};
</script>

<style lang="scss">
div.vue-pincode-input-wrapper {
  @apply flex justify-center space-x-3;
}

input.vue-pincode-input {
  @apply bg-ontick-steel-500 text-xl font-medium text-gray-300 shadow-lg;
  max-width: 39px;
  max-height: 40px;
  margin: 0px;
  transition: all 0.3s ease;
  &:focus {
    border: 2px solid #07a4ff;
  }
}
.input-tel__input {
  cursor: pointer;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  position: relative;
  width: 100%;
  padding: 0 12px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  outline: none;
  z-index: 0;
  margin-left: -1px;
  height: 40px;
  min-height: 40px;
  @apply border-ontick-carbon-500  bg-ontick-steel-500 border text-sm font-medium text-gray-300 #{!important};
}
</style>
